/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Field, Formik } from "formik";
import { Select, MultipleSelect } from "components";
import { useGetFitterAndMeasurer } from "hooks/users";
import "./user-select-form.scss";
import { ORDER_ENUM } from "enums";
import { useSearchParams } from "react-router-dom";
import { hasOrderStatus } from "utils";

interface UserSelectFormType {
  setUser: (uuid: { label: string; value: string }) => void;
  setUsersTable: (uuid: { label: string; value: string }) => void;
  orderDetails?: any;
  usersTable?: any;
}

const UserSelectForm = ({
  setUser,
  orderDetails,
  setUsersTable,
  usersTable,
}: UserSelectFormType) => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const {
    FIXED_MEASUREMENTS,
    FIXED_VERIFICATION,
    INSTALLATION_TO_BE_RELEASED,
    FIXED_INSTALLATION,
  } = ORDER_ENUM;

  const [activeUser, setActiveUser] = useState<any>();
  const { data: fitterAndMeasurer } = useGetFitterAndMeasurer();
  const { data: fitter } = useGetFitterAndMeasurer(true);
  const isEdit =
    hasOrderStatus(orderDetails?.status, [
      FIXED_MEASUREMENTS,
      FIXED_VERIFICATION,
    ]) ||
    (orderDetails?.status === FIXED_INSTALLATION && type === "additionalVisit");
  const isMultipleSelect =
    orderDetails?.status === INSTALLATION_TO_BE_RELEASED ||
    (orderDetails?.status === FIXED_INSTALLATION && type !== "additionalVisit");

  useEffect(() => {
    if (fitterAndMeasurer && !isEdit) {
      setUser(fitterAndMeasurer[0]);
    } else if (
      fitterAndMeasurer &&
      isEdit &&
      orderDetails &&
      orderDetails.employee &&
      orderDetails.employee.uuid
    ) {
      const user = fitterAndMeasurer.find(
        (item: any) => item.value === orderDetails.employee.uuid
      );
      setActiveUser(user);
      user && setUser(user);
    }
  }, [fitterAndMeasurer, orderDetails]);

  const usersSelect = fitter && [
    { label: "Wszyscy pracownicy", value: "all" },
    ...fitter,
  ];

  const initialValues = isMultipleSelect
    ? { employee: usersSelect ? usersSelect[0].value : "" }
    : {
        employee: fitterAndMeasurer
          ? isEdit && activeUser
            ? activeUser.value
            : fitterAndMeasurer[0].value
          : "",
      };

  const handleChangeUser = (e: any) => {
    const usersTable = e.map((user: any) => user.value);
    setUsersTable(usersTable);
  };

  return (
    <div className="user-select-form">
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={() => console.log(null)}
      >
        {isMultipleSelect ? (
          <Field
            label="Pracownik"
            name="employee"
            onChange={(employe: any) => handleChangeUser(employe)}
            component={MultipleSelect}
            options={usersSelect}
            size="medium"
            employee
            selectAll
            required
            white
            multiple
          />
        ) : (
          <Field
            label="Pracownik"
            name="employee"
            required
            white
            onChange={(employe: any) => setUser(employe)}
            component={Select}
            options={fitterAndMeasurer}
          />
        )}
      </Formik>
    </div>
  );
};

export default UserSelectForm;
